<template>
  <div class="product__option" v-if="customizerSchema">
    <LeverSphereLoopMobilePreview v-if="isTreatmentLeverSphereLoop" />

    <!-- Direct-pick pills (vd "Choose An Option") — không phải Shopify variant,
         chỉ là lựa chọn CMS-only đổi prompt/form, chọn trực tiếp bằng entry_id. -->
    <div class="product__option" v-if="directFormEntries.length > 1">
      <h2>{{ customizerSchema.directChoiceLabel || 'Choose An Option' }}</h2>
      <div class="product__option-choices">
        <span
          v-for="entry in directFormEntries"
          :key="entry.id"
          class="product__option-choice"
          :class="{ 'product__option-choice--actived': entry.id === selectedDirectEntryId }"
          @click="selectedDirectEntryId = entry.id"
        >
          {{ entry.label || entry.id }}
        </span>
      </div>
    </div>

    <h2>Personalization</h2>

    <div class="product-form__variants"></div>

    <div id="customily-options">
      <div class="customily-main-app">
        <div
          class="customily-options-wrapper"
          style="background-color: inherit; padding: inherit"
        >
          <div id="cl_optionsapp" class="w-100 customily-hide-scrollbar">
            <div id="customily-personalize-accordion" style="border: 0px">
              <div class="customily_sets-panel" style="background: 0px center">
                <div class="customily_sets-container">
                  <div class="customily-set">
                    <div
                      v-if="isLoopEnabled && loopCount > 1"
                      class="customily-pack-tabs-wrapper"
                    >
                      <div
                        ref="tabsContainer"
                        class="customily-pack-tabs"
                      >
                        <div
                          v-for="packIdx in loopCount"
                          :key="packIdx"
                          class="pack-tab-item"
                          :class="{ active: activePackIdx === packIdx }"
                          @click="scrollToPackItem(packIdx)"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                          </svg>
                          <span>Item {{ (packIdx) }}</span>
                        </div>
                      </div>
                      <div
                        v-if="hasMoreTabs"
                        class="customily-pack-tabs-more"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM18.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
                        </svg>
                        <div class="customily-pack-tabs-dropdown">
                          <div
                            v-for="packIdx in loopCount"
                            :key="packIdx"
                            class="dropdown-item"
                            :class="{ active: activePackIdx === packIdx }"
                            @click="scrollToPackItem(packIdx)"
                          >
                            Item {{ packIdx }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="customily_set-visibility customization-upload-image-wrapper"
                    >
                      <div
                        v-for="packIdx in loopCount"
                        :key="packIdx"
                        :id="'pack-item-' + packIdx"
                        class="customily-pack-item"
                        :style="isLoopEnabled ? 'margin-bottom: 1em; border: 1px solid #e5e7eb; border-radius: 8px; padding: 16px; background-color: #f9fafb;' : ''"
                      >
                        <div
                          v-if="isLoopEnabled"
                          class="pack-item-title"
                          style="font-weight: 700; font-size: 15px; margin-bottom: 12px; display: flex; align-items: center; justify-content: space-between;"
                        >
                          <!-- <span>Item {{ (packIdx) }}</span> -->
                          <!-- <span v-if="activePackIdx === packIdx" style="font-size: 12px; font-weight: normal; color: #10b981; display: flex; align-items: center; gap: 4px;">
                            <span style="display:inline-block; width:6px; height:6px; background:#10b981; border-radius:50%"></span> Active Preview
                          </span> -->
                        </div>
                        <LeverSphereCustomizerItem
                          :packIdx="packIdx"
                          :inputResetKey="inputResetKey"
                          :activePackIdx="activePackIdx"
                          :optionsConfig="optionsConfig"
                          :personalizationValues="getPackPersonalizationValues(packIdx)"
                          :uploaderErrors="uploaderErrors"
                          :validationErrors="validationErrors[packIdx] || {}"
                          :isStyleTransferMode="isStyleTransferMode"
                          :activeTemplateId="templateIdSelected"
                          :activeTemplate="activeTemplate"
                          :entryId="activeEntryForPrompt?.id || ''"
                          :pillCustomilyOptions="pillCustomilyOptions"
                          :allowCopyPrevious="packIdx > 1"
                          @update:personalization="(optName, value) => handlePackOptionInput(packIdx, optName, value)"
                          @upload-image="(event, optName, callbacks) => handlePackImageUploadChange(packIdx, event, optName, callbacks)"
                          @remove-image="(optName) => handlePackRemoveUploadedImage(packIdx, optName)"
                          @choose-history-image="(image, uploadUrl, optName) => handlePackChooseHistoryImage(packIdx, image, uploadUrl, optName)"
                          @update:same-as-previous="(val) => handlePackSameAsPreviousChange(packIdx, val)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <client-only>
      <ProductUpsellV3 />
    </client-only>

    <!-- Xem trước / Các thao tác Canvas (Chỉ có ở Chế độ Tiêu chuẩn) -->
    <div class="customily-preview">
      <sib-button
        @click="showPreviewPopup"
        type="button"
        role="primary"
        class="button-show-preview mr-sm mb-sm"
        ref="buttonShowPreview"
      >
        Preview Your Personalization
      </sib-button>

      <LightBoxPopup
        group="popup-preview"
        :contentId="popupID"
        @close="closePreviewPopup"
        ref="previewPopup"
      >
        <div
          class="product-popup-review__canvas-wrapper"
          ref="popupCanvasWrapper"
        >
          <div class="product-popup-review__note" style="text-align: center;">
            <p>Please check the preview carefully</p>
            <p>
              <em
                >Make sure the below customization is correct to receive your
                item faster</em
              >
            </p>
          </div>
          <div class="panzoom__viewport"></div>
          <div class="product-popup-review__button-wrapper my-md mx-md">
            <sib-button role="primary" @click="clickAddToCartOnPreview">
              Add To Cart
            </sib-button>
          </div>
        </div>
      </LightBoxPopup>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, onUnmounted, onMounted, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import type { Panzoom as PanzoomType } from '@fancyapps/ui'
import { mapRawMetadataToCustomizerSchema, resolveFormEntry } from '@/utils/customizationMapper'
import useProductStore from '@/store/product'
import useSettingStore from '@/store/setting'
import useCustomizationStore from '@/store/customization'
import LightBoxPopup from '@/ui-kits/LightBoxPopup.vue'
import ProductUpsellV3 from './ProductUpsellV3.vue'
import LeverSphereCustomizerItem from './LeverSphereCustomizerItem.vue'
import LeverSphereLoopMobilePreview from './LeverSphereLoopMobilePreview.vue'

import EventBus from '@/services/eventbus'
import Analytics from '@/services/analytics'
import CacheService, { getJSONfromCacheResponse } from '@/services/cache'
import { getRawIdFromShopifyId, isProductHasTags } from '@/utils/product'
import { cloneDeep } from '@/utils'
import {
  QUERY_STRING_NO_CACHE,
  SEVEN_DAYS_IN_MILLISECONDS,
  EVENT_PRODUCT_SHOW_PREVIEW,
  EVENT_CLICK_ADD_TO_CART_ON_POPUP_PREVIEW,
} from '@/utils'
import useABTestStoreV2 from '@/composables/abtest/store'
import { abTestGlobalKey } from '@/composables/abtest/abtestV2'
import { PDP_LEVERSPHERE_LOOP_EXPERIMENT_CAMPAIGN } from '@/composables/abtest/contexts/abtestContextLeverSphereLoop'

const emit = defineEmits<{
  (e: 'add-to-cart'): void
}>()

const route = useRoute()
const productStore = useProductStore()
const settingStore = useSettingStore()
const customizationStore = useCustomizationStore()
const abtestStore = useABTestStoreV2()

const isTreatmentLeverSphereLoop = computed(() => {
  if (route.query.in_test === 'true') return true
  return abtestStore.isReady &&
    abtestStore.code === PDP_LEVERSPHERE_LOOP_EXPERIMENT_CAMPAIGN.code &&
    abtestStore.variant === abTestGlobalKey.groupTreatment
})

// Phục vụ việc map dữ liệu từ backend sang schema đồng nhất ở frontend
const customizerSchema = computed(() => {
  if (!productStore.productTemplateConfig) return null
  return mapRawMetadataToCustomizerSchema(
    productStore.productTemplateConfig,
    productStore.product
  )
})

const isLoopEnabled = computed(() => {
  if (route.query.in_test === 'true') return true
  if (!isTreatmentLeverSphereLoop.value) return false
  return !!activeTemplate.value?.loopConfig?.enabled
})

const loopCount = computed(() => {
  if (!isLoopEnabled.value) return 1
  const selectedOptions = productStore.selectedVariant?.selectedOptions
  const packOption = selectedOptions?.find((opt: any) => opt.name.toLowerCase() === 'pack')
  if (packOption) {
    const match = packOption.value.match(/\d+/)
    if (match) {
      return parseInt(match[0], 10)
    }
  }
  return 1
})

const activePackIdx = ref(1) // Theo dõi item pack nào đang hoạt động preview
const tabsContainer = ref<HTMLElement | null>(null)
const hasMoreTabs = computed(() => loopCount.value > 3)

function scrollToTab(packIdx: number) {
  if (tabsContainer.value) {
    const tabEl = tabsContainer.value.children[packIdx - 1] as HTMLElement
    if (tabEl) {
      tabsContainer.value.scrollTo({
        left: tabEl.offsetLeft,
        behavior: 'smooth'
      })
    }
  }
}

function scrollToPackItem(packIdx: number) {
  activePackIdx.value = packIdx
  scrollToTab(packIdx)
  nextTick(() => {
    const el = document.getElementById(`pack-item-${packIdx}`)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  })
}

// Lưu trữ giá trị cá nhân hóa theo từng Pack. Ví dụ: packIdx = 1 -> { name: 'value' }
const packPersonalizationValues = ref<Record<number, Record<string, string>>>({})

function getPackPersonalizationValues(packIdx: number): Record<string, string> {
  try {
    if (!packPersonalizationValues.value[packIdx]) {
      packPersonalizationValues.value[packIdx] = {}
    }
    return packPersonalizationValues.value[packIdx]
  } catch (error: any) {
    console.error('Error in getPackPersonalizationValues:', error)
    try {
      Analytics.log('leversphere_get_pack_personalization_values_error', {
        message: error?.message || error,
        product: productStore.product?.handle,
        packIdx,
      })
    } catch (sentryErr) {}
    return {}
  }
}

const packSameAsPrevious = ref<Record<number, boolean>>({})

function getEffectivePackPersonalizationValues(packIdx: number): Record<string, string> {
  try {
    if (packIdx > 1 && (packSameAsPrevious.value[packIdx] ?? true)) {
      return cloneDeep(getPackPersonalizationValues(1))
    }
    return getPackPersonalizationValues(packIdx)
  } catch (error: any) {
    return getPackPersonalizationValues(packIdx)
  }
}

function handlePackSameAsPreviousChange(packIdx: number, val: boolean) {
  try {
    packSameAsPrevious.value[packIdx] = val
    if (validationErrors.value[packIdx]) {
      validationErrors.value[packIdx] = {}
    }

    if (packIdx === activePackIdx.value) {
      const currentVals = getEffectivePackPersonalizationValues(packIdx)
      Object.keys(personalizationValues.value).forEach((key) => {
        personalizationValues.value[key] = ''
      })
      Object.entries(currentVals).forEach(([key, val]) => {
        personalizationValues.value[key] = val
      })
      imageUploadUrl.value = currentVals['imageUploadUrl'] || ''
      imageUrlOutput.value = currentVals['imageOutputUrl'] || ''
      productStore.productPreviewImage = currentVals['imageOutputUrl'] || ''
    }
  } catch (error: any) {
    console.error('Error in handlePackSameAsPreviousChange:', error)
  }
}

function handlePackOptionInput(packIdx: number, optName: string, val: string) {
  try {
    const packVals = getPackPersonalizationValues(packIdx)
    packVals[optName] = val

    if (validationErrors.value[packIdx]?.[optName] && val?.trim()) {
      delete validationErrors.value[packIdx][optName]
    }

    // 'imageOutputUrl' là key đặc biệt (đã dùng chung với luồng upload ảnh AI) báo hiệu vừa có
    // ảnh preview mới được tạo — đồng bộ pack active + mở Step 2 review giống hệt
    // handlePackImageUploadChange, để UI luôn nhảy sang đúng pack vừa generate xong.
    if (optName === 'imageOutputUrl' && val) {
      activePackIdx.value = packIdx
      step2Open.value = true
      productStore.hasPreview = true
    }

    // Nếu pack đang sửa đổi là pack đang active preview, đồng bộ hóa sang personalizationValues của Canvas Preview
    if (packIdx === activePackIdx.value) {
      onOptionInput(optName, val)
    }
  } catch (error: any) {
    console.error('Error in handlePackOptionInput:', error)
    try {
      Analytics.log('leversphere_handle_pack_option_input_error', {
        message: error?.message || error,
        product: productStore.product?.handle,
        packIdx,
        optName,
        val,
      })
    } catch (sentryErr) {}
  }
}

async function handlePackImageUploadChange(
  packIdx: number,
  event: Event,
  optName: string,
  callbacks: { startLoading: () => void; stopLoading: () => void; saveToHistory: (image: string, uploadUrl: string) => void }
) {
  const input = event.target as HTMLInputElement
  if (!input.files || !input.files[0]) return

  const file = input.files[0]

  if (callbacks?.startLoading) callbacks.startLoading()
  uploadedFileName.value = file.name

  const uploadSessionId: string = `${Date.now()}-${Math.random().toString(36).substring(2, 11)}`
  const startTime = Date.now()
  const mediaType: string = 'image'

  try {
    Analytics.track('Upload Started', {
      upload_session_id: uploadSessionId,
      media_type: mediaType,
    })
  } catch (e) {
    console.log(e)
  }

  try {
    const payload = {
      file,
      id: templateIdSelected.value,
      isForceLoadNewData: !!route.query[QUERY_STRING_NO_CACHE],
    }

    const uploadedUrl = await customizationStore.uploadImageTransferDefault(payload)
    imageUploadUrl.value = uploadedUrl

    let finalImageUrl = uploadedUrl
    let isCompletedOutput = false

    if (isStyleTransferMode.value) {
      if (mediaUploaderOptions.value.length <= 1) {
        // Chỉ có 1 media upload, tự động gọi API AI style transfer
        const { promptCustom, inputDetails } = updateCustomConfigFromPersonalizationForPack(packIdx)
        finalImageUrl = await triggerAiStyleTransfer(
          uploadedUrl,
          promptCustom,
          inputDetails
        )
        imageUrlOutput.value = finalImageUrl
        isCompletedOutput = true
      }
    }

    const packVals = getPackPersonalizationValues(packIdx)
    // Nếu là chế độ AI Style Transfer thì value thực tế cần render/add to cart là finalImageUrl (ảnh AI)
    const targetImageValue = isStyleTransferMode.value && isCompletedOutput ? finalImageUrl : uploadedUrl
    packVals[optName] = targetImageValue
    packVals['imageUploadUrl'] = uploadedUrl
    packVals['imageOutputUrl'] = finalImageUrl
    if (validationErrors.value[packIdx]?.[optName]) {
      delete validationErrors.value[packIdx][optName]
    }
    
    if (callbacks?.saveToHistory) {
      callbacks.saveToHistory(finalImageUrl, uploadedUrl)
    }

    // Đồng bộ pack active sau khi upload hoàn thành
    activePackIdx.value = packIdx

    // Nếu là active pack, cập nhật Canvas Preview
    if (packIdx === activePackIdx.value) {
      personalizationValues.value[optName] = targetImageValue
    }

    try {
      // Lưu các input khách đã nhập và image output thực tế vào productStore khi preview AI hoàn thành
      if (!productStore.packPersonalizationInputs) {
        productStore.packPersonalizationInputs = {}
      }
      productStore.packPersonalizationInputs[packIdx] = { ...packVals }
      productStore.productPersonalizationInputs = { ...personalizationValues.value, ...packVals }

      if (finalImageUrl) {
        productStore.productOutputImageUrl = finalImageUrl
        if (!productStore.packOutputImageUrls) {
          productStore.packOutputImageUrls = []
        }
        productStore.packOutputImageUrls[packIdx - 1] = finalImageUrl
      }
    } catch (error) {
    }

    step2Open.value = true
    productStore.hasPreview = true
    EventBus.trigger(EVENT_PRODUCT_SHOW_PREVIEW)

    try {
      Analytics.track('Upload succeed', {
        file_url: targetImageValue,
        upload_session_id: uploadSessionId,
        media_type: mediaType,
        upload_time: (Date.now() - startTime) / 1000,
      })
    } catch (e) {
      console.log(e)
    }
  } catch (error: any) {
    try {
      Analytics.track('Upload failed', {
        error: error?.message || error,
        upload_session_id: uploadSessionId,
        media_type: mediaType,
        upload_time: (Date.now() - startTime) / 1000,
      })
    } catch (e) {
      console.log(e)
    }
    try {
      Analytics.log('leversphere_image_upload_exception', {
        message: error?.message || error,
        product: productStore.product?.handle,
        option: optName,
      })
    } catch (logError) {}
  } finally {
    if (input) input.value = ''
    if (callbacks?.stopLoading) callbacks.stopLoading()
  }
}

function handlePackRemoveUploadedImage(packIdx: number, optName: string) {
  try {
    const packVals = getPackPersonalizationValues(packIdx)
    packVals[optName] = ''
    packVals['imageUploadUrl'] = ''
    packVals['imageOutputUrl'] = ''

    if (packIdx === activePackIdx.value) {
      personalizationValues.value[optName] = ''
    }
  } catch (error: any) {
    console.error('Error in handlePackRemoveUploadedImage:', error)
    try {
      Analytics.log('leversphere_handle_pack_remove_uploaded_image_error', {
        message: error?.message || error,
        product: productStore.product?.handle,
        packIdx,
        optName,
      })
    } catch (sentryErr) {}
  }
}

function handlePackChooseHistoryImage(packIdx: number, image: string, uploadUrl: string, optName: string) {
  try {
    activePackIdx.value = packIdx

    const packVals = getPackPersonalizationValues(packIdx)
    // Nếu là AI mode, option value thực tế cần render là image (AI output)
    const targetVal = isStyleTransferMode.value ? image : uploadUrl
    packVals[optName] = targetVal
    packVals['imageUploadUrl'] = uploadUrl
    packVals['imageOutputUrl'] = image
    if (validationErrors.value[packIdx]?.[optName]) {
      delete validationErrors.value[packIdx][optName]
    }

    // Nếu là active pack, cập nhật canvas preview ngay
    if (packIdx === activePackIdx.value) {
      personalizationValues.value[optName] = targetVal
      imageUploadUrl.value = uploadUrl
      imageUrlOutput.value = image
      productStore.productPreviewImage = image
    }

    try {
      // Lưu các input khách đã nhập và image output thực tế vào productStore khi chọn lại ảnh lịch sử preview AI
      if (!productStore.packPersonalizationInputs) {
        productStore.packPersonalizationInputs = {}
      }
      productStore.packPersonalizationInputs[packIdx] = { ...packVals }
      productStore.productPersonalizationInputs = { ...personalizationValues.value, ...packVals }

      if (image) {
        productStore.productOutputImageUrl = image
        if (!productStore.packOutputImageUrls) {
          productStore.packOutputImageUrls = []
        }
        productStore.packOutputImageUrls[packIdx - 1] = image
      }
    } catch (error) {
    }

    step2Open.value = true
    productStore.hasPreview = true
    EventBus.trigger(EVENT_PRODUCT_SHOW_PREVIEW)
  } catch (error: any) {
    console.error('Error in handlePackChooseHistoryImage:', error)
    try {
      Analytics.log('leversphere_handle_pack_choose_history_image_error', {
        message: error?.message || error,
        product: productStore.product?.handle,
        packIdx,
        image,
        uploadUrl,
        optName,
      })
    } catch (sentryErr) {}
  }
}

function updateCustomConfigFromPersonalizationForPack(packIdx: number) {
  try {
    const promptCustom: Record<string, string> = {}
    const inputDetails: Record<string, string> = {}
    const inputNameDetails: Record<string, string> = {}
    const packVals = getPackPersonalizationValues(packIdx)

    optionsConfig.value.forEach((opt: any) => {
      if (opt.customPromptKey) {
        const val = packVals[opt.name] || ''
        promptCustom[opt.customPromptKey] = val
        inputDetails[opt.customPromptKey] = val
        inputNameDetails[opt.label] = val
      }
    })

    return { promptCustom, inputDetails, inputNameDetails }
  } catch (error: any) {
    return { promptCustom: {}, inputDetails: {}, inputNameDetails: {} }
  }
}

// Lưu trữ giá trị cá nhân hóa do người dùng nhập hoặc tải lên (key là tên thuộc tính, value là giá trị)
const personalizationValues = ref<Record<string, string>>({})

const uploaderErrors = ref<Record<string, string>>({})
const validationErrors = ref<Record<number, Record<string, string>>>({})


// DOM element tham chiếu đến vùng bao bọc canvas trong popup xem trước
const popupCanvasWrapper = ref<HTMLDivElement | null>(null)

// Tham chiếu tới instance của component LightBoxPopup dùng để xem trước toàn màn hình
const previewPopup = ref<InstanceType<typeof LightBoxPopup> | null>(null)

// Trạng thái đóng/mở của Bước 2 (REVIEW ARTWORK)
const step2Open = ref(false)

// Class Panzoom được import động từ thư viện @fancyapps/ui để hỗ trợ thu phóng ảnh xem trước
let Panzoom: typeof PanzoomType | null = null

// Đối tượng instance sau khi khởi tạo Panzoom
let panzoomInstance: PanzoomType | null = null

// ID định danh của popup xem trước tác phẩm cá nhân hóa
const popupID = 'product-popup-review'

// Mã template ID của tập tùy chọn được lấy từ customizer schema
const templateCode = computed(() => {
  return customizerSchema.value?.defaultTemplateId || ''
})

// Lựa chọn variant để chọn form (không gồm giá trị ô nhập, tránh vòng lặp khi đang gõ).
// Gộp thêm lựa chọn pill (vd "Choose An Option") vào đây dưới key là tiêu đề
// nhóm pill (`directChoiceLabel`) — để entry có condition kết hợp CẢ variant
// thật lẫn pill (vd {"Number Of Charms":"1 Charm","Choose An Option":"Dinosaur"})
// có thể khớp đúng qua cơ chế match sẵn có (nhiều key hơn thắng).
const formSelections = computed<Record<string, string>>(() => {
  const sel: Record<string, string> = {}
  productStore.selectedVariant?.selectedOptions?.forEach((opt) => {
    sel[opt.name] = opt.value
  })
  const directLabel = customizerSchema.value?.directChoiceLabel
  const pickedLabel = activeDirectEntry.value?.label
  if (directLabel && pickedLabel) sel[directLabel] = pickedLabel
  return sel
})

const activeFormEntry = computed(() => {
  const schema = customizerSchema.value
  if (!schema?.formVariantKey || !schema.formEntries?.length) return null
  return resolveFormEntry(schema.formEntries, formSelections.value)
})

// Entry không có condition = pill chọn trực tiếp (vd "Choose An Option"), không
// so khớp variant/form field nào — khách tự bấm chọn, không tự động theo gì cả.
const directFormEntries = computed(() => {
  return (customizerSchema.value?.formEntries || []).filter(
    (e) => Object.keys(e.condition).length === 0
  )
})

const selectedDirectEntryId = ref('')

// Mặc định chọn pill đầu tiên khi danh sách xuất hiện/đổi sản phẩm; reset nếu
// lựa chọn cũ không còn trong danh sách mới (vd đổi sản phẩm).
watch(
  directFormEntries,
  (entries) => {
    if (!entries.length) {
      selectedDirectEntryId.value = ''
      return
    }
    if (!entries.some((e) => e.id === selectedDirectEntryId.value)) {
      selectedDirectEntryId.value = entries[0].id
    }
  },
  { immediate: true }
)

const activeDirectEntry = computed(() => {
  return directFormEntries.value.find((e) => e.id === selectedDirectEntryId.value) || null
})

// FORM: luôn ưu tiên entry khớp variant (vd Number Of Charms) hơn pill — mỗi
// mức variant thường cần form/limit riêng, không phụ thuộc pill chọn gì.
const activeFormOptions = computed(() => {
  const schema = customizerSchema.value
  if (!schema) return []
  const entry = activeFormEntry.value || activeDirectEntry.value
  if (entry && schema.formOptionSets?.[entry.optionSetId]) {
    return schema.formOptionSets[entry.optionSetId]
  }
  return schema.options || []
})

// PROMPT: ngược lại, mặc định ưu tiên pill (khách chọn Dinosaur thì phải ra
// Dinosaur dù variant nào). Chỉ khi admin cố tình tạo 1 entry kết hợp cả 2
// trục (condition có cả key variant lẫn key pill — vd {"Number Of
// Charms":"1 Charm","Choose An Option":"Dinosaur"}) thì entry đó mới được ưu
// tiên cho cả prompt lẫn form, vì nó đã tự chứa đúng lựa chọn pill rồi.
const activeEntryForPrompt = computed(() => {
  const fe = activeFormEntry.value
  const directLabel = customizerSchema.value?.directChoiceLabel
  const feCoversPill = !!(fe && directLabel && Object.prototype.hasOwnProperty.call(fe.condition, directLabel))
  if (feCoversPill) return fe
  return activeDirectEntry.value || fe
})

// Gộp pill đang chọn thành {key: value} để truyền xuống LeverSphereCustomizerItem
// (luồng text-only, không đi qua triggerAiStyleTransfer nên cần truyền riêng).
const pillCustomilyOptions = computed<Record<string, string>>(() => {
  const directLabel = customizerSchema.value?.directChoiceLabel
  const pickedLabel = activeDirectEntry.value?.label
  return directLabel && pickedLabel ? { [directLabel]: pickedLabel } : {}
})

// Đổi form (đổi charm/pill → đổi Option Set): xoá sạch giá trị đã nhập. Không
// chỉ xoá theo tên field còn/mất — nhiều Option Set dùng chung tên field (vd
// text_1/image_1) nhưng giới hạn khác nhau (vd maxLength), nên giữ lại giá trị
// cũ dễ bị lố giới hạn mới (vd gõ "AB" ở form 2 ký tự, đổi sang form 1 ký tự
// vẫn còn "AB"). Khách phải nhập/upload lại khi đổi form.
watch(activeFormOptions, (_nextOpts, prevOpts) => {
  if ((!customizerSchema.value?.formVariantKey && !directFormEntries.value.length) || !prevOpts?.length) return
  personalizationValues.value = {}
})

// Đổi key để remount ô nhập: ui-kits/Input.vue giữ state nội bộ, không sync lại modelValue
const inputResetKey = ref(0)

// Sản phẩm có tag remove-input: đổi variant (vd Number Of Charms) thì xoá value các ô
// nhập (kể cả ô trùng tên), chỉ giữ ảnh đã upload. Ô nhập bind vào
// packPersonalizationValues nên phải xoá cả state theo pack lẫn personalizationValues.
watch(
  () => productStore.selectedVariant?.id,
  (nextId, prevId) => {
    if (!prevId || nextId === prevId) return
    if (!isProductHasTags(productStore.product, ['remove-input'])) return
    const keepKeys = new Set([
      'imageUploadUrl',
      'imageOutputUrl',
      ...optionsConfig.value.filter((o) => o.type === 'MediaUploader').map((o) => o.name),
    ])
    const clearTextValues = (vals: Record<string, string>) => {
      Object.keys(vals).forEach((key) => {
        if (!keepKeys.has(key)) delete vals[key]
      })
    }
    clearTextValues(personalizationValues.value)
    Object.values(packPersonalizationValues.value).forEach(clearTextValues)
    inputResetKey.value++
  }
)

// Các tuỳ chọn của form được lấy từ form đang active (theo entry khớp variant)
const optionsConfig = computed(() => {
  return [...activeFormOptions.value].sort((a, b) => a.sortOrder - b.sortOrder)
})

// Danh sách các tùy chọn thuộc loại tải ảnh lên (MediaUploader)
const mediaUploaderOptions = computed(() => {
  return optionsConfig.value.filter((opt) => opt.type === 'MediaUploader')
})

// --- Cấu hình và Trạng thái của chế độ AI Style Transfer ---

// Xác định sản phẩm có thuộc chế độ AI Style Transfer (chuyển đổi ảnh bằng AI) hay không dựa trên tags
const isStyleTransferMode = computed(() => {
  const styleTransferTag = settingStore.shop?.productStyleTransferTag || ''
  const hasTag = isProductHasTags(productStore.product, [styleTransferTag])

  return hasTag
})

// Danh sách thiệp chúc mừng đi kèm được cấu hình cho sản phẩm này
const greetingCardExtras = computed(() => {
  if (!settingStore.baseProductPage?.upsellGreetingCard?.length) {
    return []
  }
  return settingStore.baseProductPage?.upsellGreetingCard.filter(
    (item: { tag?: string }) =>
      isProductHasTags(productStore.product, [item?.tag || ''])
  )
})

// Cấu hình chi tiết các template phục vụ cho việc cá nhân hóa (đã chuyển sang customizerSchema)
// ID của template AI đang được người dùng chọn
const templateIdSelected = ref('')

watch(
  () => customizerSchema.value,
  (newSchema) => {
    if (newSchema && !templateIdSelected.value) {
      templateIdSelected.value = newSchema.defaultTemplateId
    }
  },
  { immediate: true }
)

// URL ảnh gốc của người dùng sau khi tải lên thành công hệ thống
const imageUploadUrl = ref('')

// URL ảnh kết quả cuối cùng sau khi chạy qua bộ xử lý AI style transfer thành công
const imageUrlOutput = ref('')

// Tên file ảnh gốc đã chọn tải lên
const uploadedFileName = ref('')

// Lịch sử các ảnh AI đã được tạo gần đây của sản phẩm này (được lưu ở Cache)
const aiStyleTransferRecently = ref<
  Array<{
    image: string
    createdAt: number
    imageUploadUrl: string
    option_sort_id: string
  }>
>([])

// Tiền tố cache giới hạn số lần chuyển đổi phong cách AI trong ngày
const AI_STYLE_TRANSFER_LIMITED_CACHE_PREFIX = 'AI-style-transfer-limited'

// Tiền tố cache lưu lịch sử ảnh AI đã tạo gần đây của sản phẩm
const AI_STYLE_TRANSFER_RECENTLY_CACHE_PREFIX = 'AI-style-transfer-recently'

// Style hiện đang hoạt động dựa trên templateIdSelected
const activeStyle = computed(() => {
  if (!customizerSchema.value?.styles) return null
  return (
    customizerSchema.value.styles.find((s) =>
      s.templates.some((t) => t.id === templateIdSelected.value)
    ) || customizerSchema.value.styles[0]
  )
})

// Template hiện đang hoạt động dựa trên templateIdSelected (đã chuyển sang customizerSchema)
const activeTemplate = computed(() => {
  if (!activeStyle.value) return null
  return (
    activeStyle.value.templates.find(
      (t) => t.id === templateIdSelected.value
    ) || activeStyle.value.templates[0]
  )
})

// Các hàm của Customizer Tiêu chuẩn

const debounceMap = new Map<string, ReturnType<typeof setTimeout>>()

function debounceTextInputTrack(optionName: string, value: string, label: string) {
  try {
    const key = optionName

    if (debounceMap.has(key)) clearTimeout(debounceMap.get(key))

    debounceMap.set(
      key,
      setTimeout(() => {
        try {
          if (!value) return

          Analytics.track('Input product page', {
            value: value,
            input_title: label,
            product_title: productStore?.product?.title,
            product_tags: productStore?.product?.tags,
            product_url: window.location.href,
          })

          debounceMap.delete(key)
        } catch (innerError: any) {
          console.error('Error inside debounce timeout:', innerError)
          try {
            Analytics.log('leversphere_debounce_timeout_error', {
              message: innerError?.message || innerError,
              product: productStore.product?.handle,
              optionName,
              value,
              label,
            })
          } catch (sentryErr) {}
        }
      }, 800)
    )
  } catch (error: any) {
    console.error('Error in debounceTextInputTrack:', error)
    try {
      Analytics.log('leversphere_debounce_text_input_track_error', {
        message: error?.message || error,
        product: productStore.product?.handle,
        optionName,
        value,
        label,
      })
    } catch (sentryErr) {}
  }
}

/**
 * Xử lý khi người dùng nhập text (InputText/TextArea).
 * Cập nhật giá trị tương ứng, vẽ đè lên canvas Fabric và làm mới ảnh xem trước.
 */
function onOptionInput(optName: string, val: string) {
  try {
    personalizationValues.value[optName] = val

    if (val) {
      const opt = optionsConfig.value.find(o => o.name === optName)
      if (opt) {
        Object.keys(uploaderErrors.value).forEach(uploaderKey => {
          if (uploaderErrors.value[uploaderKey]?.includes(opt.label)) {
            delete uploaderErrors.value[uploaderKey]
          }
        })
        debounceTextInputTrack(optName, val, opt.label)
      }
    }

  } catch (error) {}
}

/**
 * Gọi API chuyển đổi phong cách ảnh bằng AI (Style Transfer).
 * Chờ ảnh kết quả sẵn sàng thông qua cơ chế polling.
 */
async function triggerAiStyleTransfer(
  uploadedUrl: string,
  promptCustom: Record<string, string>,
  inputDetails: Record<string, string>
): Promise<string> {
  try {
    const productVariants: Record<string, string> = {}
    productStore.selectedVariant?.selectedOptions?.forEach((opt) => {
      productVariants[opt.name] = opt.value
    })
    // Gộp lựa chọn pill vào customily_options gửi BE — BE tự re-check condition
    // khớp (phòng entry_id cũ/sai) nên cần thấy đúng key/value này, giống FE.
    const directLabel = customizerSchema.value?.directChoiceLabel
    const pickedLabel = activeDirectEntry.value?.label
    if (directLabel && pickedLabel) productVariants[directLabel] = pickedLabel
    const mergedOptions = {
      '_input-details': Object.keys(inputDetails).length
        ? JSON.stringify(inputDetails)
        : '',
      ...personalizationValues.value,
      ...productVariants,
    }

    const transferPayload = {
      image: uploadedUrl,
      templateId: '9999',
      id: templateIdSelected.value,
      entry_id: activeEntryForPrompt.value?.id || '',
      custom_name: '',
      prompt_custom: Object.keys(promptCustom).length
        ? JSON.stringify(promptCustom)
        : '',
      customily_options: Object.keys(mergedOptions).length
        ? JSON.stringify(mergedOptions)
        : '',
    }

    const imageTransferedLink = await customizationStore.transferImage(
      transferPayload
    )
    if (!imageTransferedLink) {
      throw new Error('Failed to transfer style')
    }

    const isReady = await waitForImageReady(imageTransferedLink)
    if (isReady) {
      imageUrlOutput.value = imageTransferedLink
      return imageTransferedLink
    } else {
      throw new Error('Image ready check timed out')
    }
  } catch (error: any) {
    try {
      Analytics.log('leversphere_ai_style_transfer_exception', {
        message: error?.message || error,
        product: productStore.product?.handle,
        templateId: templateIdSelected.value,
      })
    } catch (logError) {}
    return ''
  }
}

/**
 * Khởi tạo bộ tùy biến tiêu chuẩn: khôi phục giá trị cũ từ query URL và setup Canvas.
 */
async function initCustomizer() {
  try {
    // Khởi tạo personalizationValues từ route query sử dụng cấu hình tuỳ chọn của metafield
    const options = optionsConfig.value
    if (options.length > 0) {
      options.forEach((opt) => {
        const queryVal = (route.query[opt.name] ||
          route.query[opt.label]) as string
        if (queryVal) {
          personalizationValues.value[opt.name] = queryVal
        }
      })
    }
  } catch (error: any) {
    try {
      Analytics.log('leversphere_init_customizer_error', { message: error?.message || error })
    } catch (logError) {}
  }
}

/**
 * Hiển thị popup xem trước toàn màn hình và khởi tạo thư viện Panzoom để hỗ trợ kéo/thu phóng ảnh.
 */
async function showPreviewPopup() {
  try {
    Analytics.track('Preview clicked')
    previewPopup.value?.show()

    requestAnimationFrame(() => {
      const previewEl = document.createElement('img')
      previewEl.id = 'leversphere-preview-image'
      previewEl.src = productStore.productPreviewImage || ''

      if (!popupCanvasWrapper.value) return

      if (isProductHasTags(productStore.product, ['watermark', 'leversphere_watermark'])) {
        if (typeof window !== 'undefined') {
          if (!document.documentElement.style.getPropertyValue('--customily-watermark-image')) {
            const domain = window.location.hostname || window.location.host || 'hopesify.com'
            const capitalizedDomain = domain.charAt(0).toUpperCase() + domain.slice(1)
            const encodedDomain = encodeURIComponent(capitalizedDomain)
            const svg = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='200'%3E%3Cstyle%3Etext %7B font-size: 22px; font-weight: bold; font-family: Arial, sans-serif; fill: rgba(0,0,0,0.13); text-anchor: middle; %7D%3C/style%3E%3Ctext transform='translate(75, 50) rotate(-30)'%3E${encodedDomain}%3C/text%3E%3Ctext transform='translate(225, 50) rotate(-30)'%3E${encodedDomain}%3C/text%3E%3Ctext transform='translate(150, 150) rotate(-30)'%3E${encodedDomain}%3C/text%3E%3Ctext transform='translate(0, 150) rotate(-30)'%3E${encodedDomain}%3C/text%3E%3Ctext transform='translate(300, 150) rotate(-30)'%3E${encodedDomain}%3C/text%3E%3C/svg%3E")`
            document.documentElement.style.setProperty('--customily-watermark-image', svg)
          }
        }
        popupCanvasWrapper.value.classList.add('has-watermark')
      }

      const panZoomViewport = popupCanvasWrapper.value.querySelector(
        '.panzoom__viewport'
      ) as HTMLElement
      if (!panZoomViewport) return

      panZoomViewport.innerHTML = ''

      const wrapperWidth = popupCanvasWrapper.value.clientWidth
      const maxWidth = Math.min(wrapperWidth, document.body.clientWidth * 0.95)
      const maxHeight = Math.min(
        wrapperWidth,
        document.body.clientHeight * 0.85
      )
      const width = Math.min(maxWidth, maxHeight)

      previewEl.style.width = width + 'px'
      previewEl.style.height = 'auto'
      previewEl.style.maxWidth = 'none'
      previewEl.style.maxHeight = 'none'
      popupCanvasWrapper.value.style.width = width + 'px'
      popupCanvasWrapper.value.style.height = 'auto'
      popupCanvasWrapper.value.style.margin = '0 auto'

      panZoomViewport.appendChild(previewEl)
      requestAnimationFrame(async () => {
        if (!Panzoom) {
          Panzoom = (await import('@fancyapps/ui')).Panzoom
        }
        previewEl.classList.add('panzoom__content')
        panzoomInstance = new Panzoom(popupCanvasWrapper.value, {
          width: width,
          height: width,
          panOnly: true,
          click: false,
          doubleClick: false,
          wheel: false,
          pinchToZoom: false,
        })
      })
    })
  } catch (error: any) {
    try {
      Analytics.log('leversphere_show_preview_popup_error', { message: error?.message || error })
    } catch (logError) {}
  }
}

/**
 * Đóng popup xem trước và hủy đối tượng Panzoom để tránh rò rỉ bộ nhớ.
 */
function closePreviewPopup() {
  try {
    if (panzoomInstance) {
      panzoomInstance.destroy()
      panzoomInstance = null
    }
    const previewImg = document.getElementById('leversphere-preview-image')
    if (previewImg) {
      previewImg.remove()
    }
  } catch (error) {}
}

/**
 * Bấm nút "Add To Cart" từ popup preview: kích hoạt emit sự kiện thêm vào giỏ hàng và đóng popup.
 */
function clickAddToCartOnPreview() {
  try {
    emit('add-to-cart')
    previewPopup.value?.close()
    EventBus.trigger(EVENT_CLICK_ADD_TO_CART_ON_POPUP_PREVIEW)
  } catch (error) {}
}

/**
 * Lấy lịch sử các ảnh AI Style Transfer đã tạo gần đây lưu trong cache (lọc trong vòng 7 ngày).
 */
async function getAiStyleTransferRecently() {
  try {
    const productHandle = productStore.product?.handle
    if (!productHandle) return []
    const cacheKey = `${AI_STYLE_TRANSFER_RECENTLY_CACHE_PREFIX}_${productHandle}`
    const cacheResponse = await CacheService.instance?.get(cacheKey)
    const aiStyleTransferRecentlyFromCache =
      getJSONfromCacheResponse(cacheResponse)
    if (aiStyleTransferRecentlyFromCache) {
      const now = Date.now()
      const sevenDaysAgo = now - 7 * 24 * 60 * 60 * 1000
      aiStyleTransferRecently.value = aiStyleTransferRecentlyFromCache.filter(
        (item: { createdAt: number }) => {
          const itemTime = new Date(item.createdAt).getTime()
          return itemTime >= sevenDaysAgo && itemTime <= now
        }
      )
      if (
        aiStyleTransferRecently.value.length !==
        aiStyleTransferRecentlyFromCache.length
      ) {
        await CacheService.instance?.delete(cacheKey)
        CacheService.instance?.set(
          cacheKey,
          cloneDeep(aiStyleTransferRecently.value),
          SEVEN_DAYS_IN_MILLISECONDS
        )
      }
      return aiStyleTransferRecently.value
    }
    return []
  } catch (error: any) {
    try {
      Analytics.log('leversphere_get_ai_style_transfer_recently_error', { message: error?.message || error })
    } catch (logError) {}
    return []
  }
}

/**
 * Tính số mili-giây còn lại từ thời điểm hiện tại cho đến cuối ngày (23:59:59).
 */
function getMillisecondsUntilEndOfDay() {
  try {
    const now = new Date()
    const endOfDay = new Date(now)
    endOfDay.setHours(23, 59, 59, 999)
    return endOfDay.getTime() - now.getTime()
  } catch (error) {
    return 0
  }
}

/**
 * Thiết lập số lượt preview AI miễn phí mặc định trong ngày (10 lượt) vào cache nếu chưa tồn tại.
 */
async function setDefaultAiStyleTransferLimited() {
  try {
    const productHandle = productStore.product?.handle
    if (!productHandle) return
    const cacheKey = `${AI_STYLE_TRANSFER_LIMITED_CACHE_PREFIX}_${productHandle}`
    const cacheResponse = await CacheService.instance?.get(cacheKey)
    const aiTransferLimitedFromCache = getJSONfromCacheResponse(cacheResponse)
    if (!aiTransferLimitedFromCache) {
      const ttl = getMillisecondsUntilEndOfDay()
      CacheService.instance?.set(cacheKey, transferLimited, ttl)
    }
  } catch (error) {}
}

/**
 * Polling liên tục kiểm tra xem ảnh đã được AI xử lý xong và tải thành công lên Cloud chưa.
 */
async function waitForImageReady(
  url: string,
  interval = 10000,
  maxAttempts = 60
) {
  try {
    for (let i = 1; i <= maxAttempts; i++) {
      const isReady = await new Promise<boolean>((resolve) => {
        const img = new Image()
        img.onload = () => resolve(true)
        img.onerror = () => resolve(false)
        img.src = url + (url.includes('?') ? '&' : '?') + 't=' + Date.now()
      })
      if (isReady) return true
      if (i < maxAttempts) {
        await new Promise((r) => setTimeout(r, interval))
      }
    }
    return false
  } catch (error: any) {
    try {
      Analytics.log('leversphere_wait_for_image_ready_error', { message: error?.message || error, url })
    } catch (logError) {}
    return false
  }
}

const transferLimited = 10

let uploadProgressInterval: any = null

/**
 * Thu thập và đóng gói dữ liệu cá nhân hóa (base64 canvas, URL chia sẻ) để gửi lên giỏ hàng / checkout.
 */
function getPersonalizationDetails(packIdx?: number) {
  try {
    const origin = settingStore.shop?.domain
      ? `https://${settingStore.shop.domain}`
      : ''
    const pathname = route.path
    const isPack = packIdx !== undefined
    const packVals = isPack ? getEffectivePackPersonalizationValues(packIdx) : personalizationValues.value

    const inputNameDetails: Record<string, string> = {}
    optionsConfig.value.forEach((opt: any) => {
      const val = packVals[opt.name] || ''
      if (opt.customPromptKey) {
        inputNameDetails[opt.label] = val
      } else if (opt.type === 'InputText' || opt.type === 'TextArea') {
        inputNameDetails[opt.label] = val
      }
    })
    const inputNameDetailsStr = Object.keys(inputNameDetails).length
      ? JSON.stringify(inputNameDetails)
      : ''

    if (isStyleTransferMode.value) {
      const promptCustom: Record<string, string> = {}

      optionsConfig.value.forEach((opt: any) => {
        if (opt.customPromptKey) {
          const val = packVals[opt.name] || ''
          promptCustom[opt.customPromptKey] = val
        }
      })

      // Xây dựng URL tùy chỉnh với các tham số
      const params = new URLSearchParams()
      if (productStore.selectedVariant?.id) {
        params.set(
          'variant',
          getRawIdFromShopifyId(productStore.selectedVariant.id)
        )
      }
      optionsConfig.value.forEach((opt: any) => {
        const val = packVals[opt.name] || ''
        if (val) {
          params.set(opt.name, val)
        }
      })
      const uploadUrl = packVals['imageUploadUrl'] || ''
      const outputUrl = packVals['imageOutputUrl'] || ''
      if (uploadUrl) {
        params.set('imageUploadUrl', uploadUrl)
      }
      if (outputUrl) {
        params.set('imageOutputUrl', outputUrl)
      }
      const customizationUrl = `${origin}${pathname}?${params
        .toString()
        .replace(/\+/g, '%20')}`

      const effectivePackIdx = (isPack && packIdx !== undefined && packIdx > 1 && (packSameAsPrevious.value[packIdx] ?? true)) ? 1 : packIdx
      const previewSrc = isPack && effectivePackIdx !== undefined
        ? productStore.packPreviewImages?.[effectivePackIdx - 1]
        : productStore.productPreviewImage
      const imageOutputCanvasUrl = previewSrc?.startsWith('data:image') ? previewSrc : ''

      return {
        isStyleTransfer: true,
        imageOutputUrl: outputUrl || imageUrlOutput.value || '',
        imageUploadUrl: uploadUrl || imageUploadUrl.value || '',
        imageOutputCanvasUrl: imageOutputCanvasUrl || outputUrl || imageUrlOutput.value || '',
        inputNameDetails: inputNameDetailsStr,
        customizationUrl,
        voiceOutputUrl: packVals['voiceOutputUrl'] || '',
      }
    }

    const effectivePackIdx = (isPack && packIdx !== undefined && packIdx > 1 && (packSameAsPrevious.value[packIdx] ?? true)) ? 1 : packIdx
    const previewSrc = isPack && effectivePackIdx !== undefined
      ? productStore.packPreviewImages?.[effectivePackIdx - 1]
      : productStore.productPreviewImage
    const base64 = previewSrc?.startsWith('data:image') ? previewSrc : ''

    const params = new URLSearchParams()
    if (productStore.selectedVariant?.id) {
      params.set(
        'variant',
        getRawIdFromShopifyId(productStore.selectedVariant.id)
      )
    }
    optionsConfig.value.forEach((opt: any) => {
      const val = packVals[opt.name] || ''
      if (val) {
        params.set(opt.name, val)
      }
    })

    const customizationUrl = `${origin}${pathname}?${params
      .toString()
      .replace(/\+/g, '%20')}`

    return {
      isStyleTransfer: false,
      imageOutputCanvasUrl: base64,
      base64,
      imageOutputUrl: '',
      imageUploadUrl: '',
      inputNameDetails: inputNameDetailsStr,
      customizationUrl,
      voiceOutputUrl: packVals['voiceOutputUrl'] || '',
    }
  } catch (error: any) {
    try {
      Analytics.log('leversphere_get_personalization_details_error', { message: error?.message || error, packIdx })
    } catch (logError) {}
    return {
      isStyleTransfer: false,
      imageOutputCanvasUrl: '',
      base64: '',
      imageOutputUrl: '',
      imageUploadUrl: '',
      inputNameDetails: '',
      customizationUrl: '',
      voiceOutputUrl: '',
    }
  }
}

function validate(): boolean {
  try {
    validationErrors.value = {}
    let isValid = true
    let firstInvalidPackIdx = -1
    let firstInvalidOptIndex = -1

    const count = isLoopEnabled.value ? loopCount.value : 1
    for (let packIdx = 1; packIdx <= count; packIdx++) {
      const packVals = getEffectivePackPersonalizationValues(packIdx) || {}
      const options = optionsConfig.value || []

      for (let i = 0; i < options.length; i++) {
        const opt = options[i]
        if (opt.required) {
          const val = packVals[opt.name]
          if (!val || !val.trim()) {
            isValid = false
            if (!validationErrors.value[packIdx]) {
              validationErrors.value[packIdx] = {}
            }
            const cleanLabel = opt.label ? opt.label.replace('*', '').trim() : 'This field'
            const errorMessage = `${cleanLabel} is required`
            validationErrors.value[packIdx][opt.name] = errorMessage

            if (firstInvalidPackIdx === -1) {
              firstInvalidPackIdx = packIdx
              firstInvalidOptIndex = i

              try {
                Analytics.track('errors', { message: errorMessage })
              } catch (e) {
                console.log(e)
              }
            }
          }
        }
      }
    }

    // Voice template: phải tạo xong audio mới cho thêm vào giỏ
    if (activeTemplate.value?.hasVoice) {
      for (let packIdx = 1; packIdx <= count; packIdx++) {
        const packVals = getEffectivePackPersonalizationValues(packIdx) || {}
        if (!packVals['voiceOutputUrl']) {
          isValid = false
          if (!validationErrors.value[packIdx]) {
            validationErrors.value[packIdx] = {}
          }
          validationErrors.value[packIdx]['__voice'] = 'Please create your voice first.'
          if (firstInvalidPackIdx === -1) {
            firstInvalidPackIdx = packIdx
            firstInvalidOptIndex = (optionsConfig.value || []).length - 1
          }
        }
      }
    }

    if (!isValid) {
      if (isLoopEnabled.value && firstInvalidPackIdx !== -1) {
        activePackIdx.value = firstInvalidPackIdx
      }
      nextTick(() => {
        const packElem = document.getElementById(`pack-item-${firstInvalidPackIdx}`)
        if (packElem) {
          const optionElems = packElem.querySelectorAll('.customily_option')
          const targetOptElem = optionElems[firstInvalidOptIndex] || packElem
          const inputOrElem = (targetOptElem.querySelector('input, textarea, select, .sib-file-select') || targetOptElem) as HTMLElement

          inputOrElem.scrollIntoView({ behavior: 'smooth', block: 'center' })
          if (typeof inputOrElem.focus === 'function') {
            inputOrElem.focus({ preventScroll: true })
          }
        }
      })
      return false
    }

    return true
  } catch (error) {
    return true
  }
}

defineExpose({
  getPersonalizationDetails,
  customizerSchema,
  optionsConfig,
  isLoopEnabled,
  loopCount,
  validate,
  imageUrlOutput,
  imageUploadUrl,
  aiStyleTransferRecently,
  getEffectivePackPersonalizationValues,
})

watch(activePackIdx, (newIdx) => {
  // Đồng bộ personalizationValues với pack được chọn
  const packVals = getEffectivePackPersonalizationValues(newIdx)
  
  // Clean values hiện tại
  Object.keys(personalizationValues.value).forEach((key) => {
    personalizationValues.value[key] = ''
  })
  
  // Set values mới của pack được chọn
  Object.entries(packVals).forEach(([key, val]) => {
    personalizationValues.value[key] = val
  })

  // Đồng bộ lại các biến trạng thái hiển thị của AI preview ở component cha
  imageUploadUrl.value = packVals['imageUploadUrl'] || ''
  imageUrlOutput.value = packVals['imageOutputUrl'] || ''
  productStore.productPreviewImage = packVals['imageOutputUrl'] || ''

  // Phát sự kiện đồng bộ slider thumbnail
  EventBus.trigger('select-active-pack-idx', newIdx)
})

let unwatchTemplateCode: (() => void) | null = null
let unwatchProductId: (() => void) | null = null

const handleSelectActivePackIdx = (idx: number) => {
  if (activePackIdx.value !== idx) {
    activePackIdx.value = idx
  }
}

onMounted(async () => {
  try {
    unwatchTemplateCode = watch(
      () => templateCode.value,
      (newCode) => {
        if (newCode) {
          initCustomizer()
        }
      },
      { immediate: true }
    )

    unwatchProductId = watch(
      () => productStore.product?.id,
      (id) => {
        if (id) {
          productStore.numberOfPersonalizedProductVisited++
        }
      },
      { immediate: true }
    )

  if (isStyleTransferMode.value) {
    setDefaultAiStyleTransferLimited()
    getAiStyleTransferRecently()
  }

  EventBus.on('select-active-pack-idx', handleSelectActivePackIdx)
  try {
    Analytics.track('LeversphereCustomizer mounted', {
      tags: productStore.product?.tags || []
    })
  } catch (error) {
  }
  } catch (error) {
  }
})

onUnmounted(() => {
  try {
    if (unwatchTemplateCode) unwatchTemplateCode()
    if (unwatchProductId) unwatchProductId()
    EventBus.off('select-active-pack-idx', handleSelectActivePackIdx)
    if (panzoomInstance) {
      panzoomInstance.destroy()
    }

    if (uploadProgressInterval) {
      clearInterval(uploadProgressInterval)
    }

    debounceMap.forEach((timeout) => clearTimeout(timeout))
    debounceMap.clear()
  } catch (e) {
    console.log(e)
  }
})
</script>

<style lang="scss">
.leversphere-options-wrapper {
  background-color: var(--background-color);
  border: solid 1px var(--border-color);
  border-radius: var(--border-radius-small);
  padding: 1.5em;
  margin-bottom: 1em;

  .sib-form-item {
    margin-bottom: 1.2em;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.canvas-wrapper {
  width: 100%;
  max-width: 100%;
  height: auto;
  aspect-ratio: 1 / 1;
  &.leversphere-ai-preview-wrapper {
    aspect-ratio: unset;
    height: auto;
  }
  .canvas-container {
    width: 100% !important;
    height: 100% !important;
    margin: 0 auto;
  }
  canvas {
    width: 100% !important;
    height: 100% !important;
  }
}

.customization-style-transfer-upload-image-button-wrap {
  display: flex;
  align-items: center;
  .sib-file-select-wrapper {
    width: auto;
  }
  .style-transfer-image-preview {
    margin-left: 8px;
    width: 42px;
    height: 42px;
    object-fit: contain;
    border: 1px solid #d5d5d5;
  }
}

.ai-style-transfer-recently {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  max-width: 320px;
  margin-bottom: 6px;

  &::-webkit-scrollbar-track {
    background-color: var(--background-color);
  }

  &::-webkit-scrollbar {
    height: 7px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #b4b4b4;
    border-radius: 1rem;
  }

  &__item {
    background-color: transparent;
    box-sizing: border-box;
    box-shadow: 0 0 2px 1px #0003;
    border: 3px solid #fff;
    width: 62px;
    height: 62px;
    transition: all 0.3s ease;
    cursor: pointer;
    margin: 5px 5px 3px 4px;

    img {
      width: 56px;
      height: 56px;
      object-fit: contain;
    }
  }
}

.ai-style-transfer-history-title {
  font-weight: 600;
  margin: 14px 0 2px 0;
}

.rate-limit-transfer-message {
  font-size: 12px;
  color: var(--color-secondary);
  margin-top: 8px;
  margin-bottom: 8px;
}

.remove-custom-upload-image {
  padding: 14px 11px;
}

.generate-loading {
  --loading-size: 16px;
  --loading-line-width: 2px;
  color: #ffffff;
  transform: translateX(-6px);
}

.generate-button {
  max-width: 170px;
  padding-left: 8px;
  padding-right: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.disable-button {
  pointer-events: none;
}

.product-popup-review__canvas-wrapper {
  align-items: center;

  .panzoom__viewport {
    position: relative;
  }
}

#product-popup-review {
  .is-close {
    top: 12px !important;
    right: 9px !important;
  }
}

.help-text {
  font-size: 80%;
  line-height: 1.4;
  color: #9e9e9e !important;
  margin-top: 8px;
  display: block;
}

#customily-options select,
#customily-options input {
  border: 1px solid #d5d5d5 !important;
  padding-left: 15px !important;
  height: 45px !important;
  line-height: 25px !important;
  width: 100% !important;
  background: #ffffff !important;
}

.customily-pack-tabs-wrapper {
  position: relative;
  width: 0;
  min-width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 1em;

  @include media-md-up {
    position: sticky;
    top: var(--fixed-content-height, 0);
    z-index: 10;
    background-color: #f9fafb;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 24px;
    height: 100%;
    background: linear-gradient(to right, rgba(0, 0, 0, 0.06), transparent);
    pointer-events: none;
    z-index: 2;
  }
}

.customily-pack-tabs {
  position: relative;
  display: flex;
  align-items: center;
  gap: 24px;
  flex: 1;
  overflow-x: auto;
  padding-bottom: 0px;
  scrollbar-width: none;
  box-sizing: border-box;
  
  &::-webkit-scrollbar {
    display: none;
  }

  .pack-tab-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 12px 4px;
    font-size: 14px;
    font-weight: 600;
    color: #374151;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    transition: all 0.2s ease;
    white-space: nowrap;

    svg {
      width: 16px;
      height: 16px;
      color: #374151;
      transition: all 0.2s ease;
    }

    &:hover {
      color: #e05638;
      svg {
        color: #e05638;
      }
    }

    &.active {
      color: #e05638;
      border-bottom-color: #e05638;
      svg {
        color: #e05638;
      }
    }
  }
}

.customily-pack-tabs-more {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: pointer;
  color: #374151;
  flex-shrink: 0;
  margin-left: 8px;
  padding-bottom: 2px;
  transition: color 0.2s ease;

  svg {
    width: 16px;
    height: 16px;
    color: #374151;
    transition: color 0.2s ease;
  }

  &:hover {
    color: #e05638;
    svg {
      color: #e05638;
    }
    .customily-pack-tabs-dropdown {
      display: block;
    }
  }
}

.customily-pack-tabs-dropdown {
  display: none;
  position: absolute;
  top: 100%;
  right: 0;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  padding: 4px 0;
  min-width: 100px;
  z-index: 50;

  .dropdown-item {
    padding: 8px 12px;
    font-size: 13px;
    color: #374151;
    white-space: nowrap;
    text-align: left;
    transition: background-color 0.2s;

    &:hover {
      background-color: #f3f4f6;
      color: #e05638;
    }

    &.active {
      color: #e05638;
      font-weight: 600;
      background-color: #fdf2f0;
    }
  }
}
</style>
